import { Dispatch } from 'redux';
import { searchDepOnlineService } from './DepOnline.services';
import {
  SetResultLoadingType,
  DEP_ONLINE_SET_LOADING,
  RESET_RESULTS,
  ResetResultsType,
} from './DepOnline.types';
import {
  httpError,
  json,
  showWarnNotification,
  showSuccessNotification,
} from 'common';

const setResultLoading = (loading: boolean): SetResultLoadingType => ({
  type: DEP_ONLINE_SET_LOADING,
  loading,
});

export const resetResults = (): ResetResultsType => ({
  type: RESET_RESULTS,
});

export const searchDepOnline =
  (formValues: any, exportFormat: string, token: string) =>
  (dispatch: Dispatch) => {
    const body = { ...formValues, exportFormat };
    dispatch(setResultLoading(true));
    dispatch(resetResults());
    searchDepOnlineService(body, token)
      .then(httpError(dispatch))
      .then(json)
      .then((response: any) => {
        if (response.errorMessage) throw Error(response.errorMessage);
        showSuccessNotification(
          'NYC DEP Online',
          'Your documents will be ready soon. Please check "Recent Reports".',
        );
        dispatch(setResultLoading(false));
      })
      .catch((error: any) => {
        dispatch(setResultLoading(false));
        showWarnNotification('NYC DEP Online', error.message);
      });
  };
